import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = { class: "my-4 d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "max-width": "700",
    modelValue: _ctx.isDialogOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isDialogOpen) = $event)),
    "onClick:outside": _ctx.closeDialog
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_page_title, { value: `新規献立種別作成` }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.categoryName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryName) = $event)),
              variant: "outlined",
              label: "種別名",
              color: "primary"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.targetClassIds,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetClassIds) = $event)),
              multiple: "",
              variant: "outlined",
              label: "対象クラス",
              items: _ctx.classes,
              "item-title": (item) => item.year + '年度' + item.className,
              "item-value": "classId",
              color: "primary"
            }, null, 8, ["modelValue", "items", "item-title"])
          ]),
          (_ctx.isCreating)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: "",
                color: "primary",
                class: "my-4"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "flat",
              disabled: !_ctx.isCreationValid || _ctx.isCreating,
              onClick: _ctx.createCategory
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("作成", -1)
              ]))]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_v_spacer)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onClick:outside"]))
}